/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementMediumResponse { 
    id: string;
    nameCyrillic?: string;
    nameLatin?: string;
    type?: ManagementMediumResponse.TypeEnum;
    lang?: ManagementMediumResponse.LangEnum;
    mediaUrl?: string;
    siteVisits?: number;
    facebookFollowers?: number;
    commercialValue?: number;
    facebookLink?: string;
    iptvUrl?: string;
    subscription?: number;
}
export namespace ManagementMediumResponse {
    export type TypeEnum = 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    export const TypeEnum = {
        PRINTED: 'PRINTED' as TypeEnum,
        WEB: 'WEB' as TypeEnum,
        TV: 'TV' as TypeEnum,
        RADIO: 'RADIO' as TypeEnum,
        SOCIAL: 'SOCIAL' as TypeEnum
    };
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}